import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-delegates',
  templateUrl: './my-delegates.component.html',
  styleUrls: ['./my-delegates.component.scss']
})
export class MyDelegatesComponent implements OnInit {
  sectionTitle = 'My Delegates'

  MDInfo = {
    info: 'Share your plan with trusted friends, family and professional advisers, so those closest to you can access the right information at the right time.',
    title: 'My Delegates',
    content: 'Proinde die funestis interrogationibus praestituto imaginarius iudex equitum resedit magister adhibitis aliis iam quae essent agenda praedoctis, et adsistebant hinc inde notarii, quid quaesitum esset, quidve responsum, cursim ad Caesarem perferentes, cuius imperio truci, stimulis reginae exsertantis aurem subinde per aulaeum, nec diluere obiecta permissi nec defensi periere conplures.'
  }
  
  MDButtons = [
    {
      type: 'submit',
      className: 'btn next-btn mb-2 mr-sm-2',
      value: 'view my delegates',
      url:'/dynamicgrid/delegates-grid'
    },
    {
      type: 'submit',
      className: 'btn next-btn mb-2 mr-sm-2',
      value: 'add a new delegate',
      url:'/dynamicformdataentry/delegate_1'
    }
  ]

  cardRectoVerso = [
    {
      rectoCardToggle: 'card-toggle card-recto',
      rectoCardBodyToggle: 'card-body-toggle',
      fa: 'fa fa-3x fas fa-eye',
      rectoCardTitle: 'card-title',
      rectoCardText: 'now',
      versoCardToggle: 'card-toggle card-verso',
      versoCardBoddyToggle: 'card-body-toggle',
      versoCardTitle: 'card-title',
      versoCardText: 'Text'
    },
    {
      rectoCardToggle: 'card-toggle card-recto',
      rectoCardBodyToggle: 'card-body-toggle',
      fa: 'fa fa-3x fas fa-pencil-alt',
      rectoCardTitle: 'card-title',
      rectoCardText: 'contributer',
      versoCardToggle: 'card-toggle card-verso',
      versoCardBoddyToggle: 'card-body-toggle',
      versoCardTitle: 'card-title',
      versoCardText: 'Text'
    },
    {
      rectoCardToggle: 'card-toggle card-recto',
      rectoCardBodyToggle: 'card-body-toggle',
      fa: 'fa fa-3x fas fa-hourglass-half',
      rectoCardTitle: 'card-title',
      rectoCardText: 'future',
      versoCardToggle: 'card-toggle card-verso',
      versoCardBoddyToggle: 'card-body-toggle',
      versoCardTitle: 'card-title',
      versoCardText: 'Text'
    },
    {
      rectoCardToggle: 'card-toggle card-recto',
      rectoCardBodyToggle: 'card-body-toggle',
      fa: 'fa fa-3x fas fa-eye-slash',
      rectoCardTitle: 'card-title',
      rectoCardText: 'never',
      versoCardToggle: 'card-toggle card-verso',
      versoCardBoddyToggle: 'card-body-toggle',
      versoCardTitle: 'card-title',
      versoCardText: 'Text'
    }
  ]


  constructor() { }

  ngOnInit() {
  }

}
